import React from "react";
import { Menu } from "lucide-react";

export type MenuButtonProps = {
  onClick: () => void;
};

export default function MenuButton(props: MenuButtonProps) {
  return (
      <button onClick={props.onClick}>
        <Menu size={28} />
      </button>
  );
}
